import React from 'react';
import Footer from '../Footer/Footer';
import Contact from '../Home/Contact/Contact';
import Navbar from '../Navbar/Navbar';

const Contacts = () => {
    return (
        <div>
            <Navbar/>
            <Contact/>
            <Footer/>
        </div>
    );
};

export default Contacts;